import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

/**
 * Správy pre prihláseného používateľa - okrem verejných aj tie určené len
 * prihláseným a tie cielené na jeho roly. Aplikáciu si server berie z tokenu.
 */
export const getMeMessages = createQueryFn(
  QueryNameSpace.getMeMessages,
  async () => await CoreApi.getMeMessages(),
);
